"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
interface FaqItem {
  id: string;
  question: string;
  answer: string;
}
const FAQ_ITEMS: FaqItem[] = [{
  id: "item-1",
  question: "Can you tell me how long I will live?",
  answer: "No. PhysAnalytica does not predict individual lifespan. Longevity assessments focus on measurable aspects of fitness, movement and physical capacity."
}, {
  id: "item-2",
  question: "What is the most useful fitness measurement?",
  answer: "There is no single measurement that describes overall health. VO₂ Max provides information about cardiorespiratory fitness, while movement, balance and metabolic measurements answer different questions."
}, {
  id: "item-3",
  question: "Is VO₂ Max related to long-term health?",
  answer: "Higher cardiorespiratory fitness is associated in population research with better health outcomes, but an individual result does not determine future health or lifespan."
}, {
  id: "item-4",
  question: "Is this only for older people?",
  answer: "No. Establishing baseline fitness and movement measurements can be useful across adulthood."
}, {
  id: "item-5",
  question: "Can athletes use these assessments?",
  answer: "Yes. The same physiological and biomechanical measurements can also support sport and performance decision-making."
}, {
  id: "item-6",
  question: "Can I repeat the assessments?",
  answer: "Yes. Repeating comparable tests can help monitor changes over time."
}, {
  id: "item-7",
  question: "Does an RMR test tell me exactly what to eat?",
  answer: "No. RMR measures resting energy expenditure. Nutrition requirements also depend on activity, goals and other individual factors."
}];
export default function Faq() {
  return <section id="faq" data-nav="light" className="bg-background text-foreground py-16 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="mb-10 sm:mb-12 text-center">
          <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
            Frequently asked questions
          </h2>
        </div>

        <div className="rounded-xl border border-border bg-card p-6 shadow-xs sm:p-8">
          <Accordion type="single" collapsible className="w-full">
            {FAQ_ITEMS.map((item, index) => <AccordionItem key={item.id} value={item.id} data-index={index} className="border-border py-1">
                <AccordionTrigger className="text-left text-base font-medium text-foreground hover:no-underline hover:text-primary sm:text-lg">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-muted-foreground sm:text-base">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}